import controller from './change-payment-info.controller';

export default {
  controller,
  template: require('./change-payment-info.html')
};



// WEBPACK FOOTER //
// src/app/buy/change-payment-info-dialog/change-payment-info.component.ts